import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private activeToast?: HTMLElement;

  showNotification(
    message: string,
    verticalPosition: 'top' | 'bottom' = 'top',
    panelClass: 'success' | 'error' | 'warning' = 'success',
    status: number
  ) {
    if (status === 401 && typeof window !== 'undefined') {
      window.localStorage.clear();
      window.location.reload();
    }

    if (typeof window === 'undefined') {
      return null;
    }

    this.activeToast?.remove();

    const toast = document.createElement('div');
    toast.className = `app-toast app-toast--${verticalPosition} app-toast--${panelClass}`;
    toast.setAttribute('role', panelClass === 'error' ? 'alert' : 'status');
    toast.textContent = message || 'API failed, Please try again after some time!!';
    document.body.appendChild(toast);
    this.activeToast = toast;

    window.requestAnimationFrame(() => {
      toast.classList.add('app-toast--visible');
    });

    window.setTimeout(() => {
      toast.classList.remove('app-toast--visible');
      window.setTimeout(() => {
        if (this.activeToast === toast) {
          this.activeToast = undefined;
        }
        toast.remove();
      }, 200);
    }, 4000);

    return toast;
  }

}
